// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__prt9E","overflowing":"ReadFullNote_overflowing__1nBsm"};